import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {CheckIcon, SearchIcon, ThinCloseIcon, ThinNotAllowedIcon} from "../../../components/icons/material-icons";
import {GradeToString} from "../students/list";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";

interface classStudentsInterface {
    id: number, // studentId
    firstname: string,
    lastname: string,
    grade: number,
    isSelected: boolean,
    isAvailable: boolean,
}

export const AdminsAssignStudentsToClass = (props: {
    active: boolean,
    closeHandler: any,
    onDone: any,
    classId: number,
    classTitle: string
}) => {
    const [loaded, setLoaded] = useState(false);
    const [list, setList] = useState([] as classStudentsInterface[]);
    const fetchList = () => {
        setLoaded(false);
        const classId = props.classId;
        PostJSON(
            Apis.server + '/core/admins/class/get-assign',
            {classId:classId},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: {
                    id: number, // studentId
                    firstname: string,
                    lastname: string,
                    grade: number,
                    classId: number,
                }[] | null
            }) => {
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setLoaded(true);
                let lst = [] as classStudentsInterface[];
                if (d.list !== null) {
                    d.list.forEach((s, i) => {
                        lst.push({
                            id: s.id,
                            firstname: s.firstname,
                            lastname: s.lastname,
                            grade: s.grade,
                            isAvailable: s.classId === 0 || s.classId === classId,
                            isSelected: s.classId === classId,
                        });
                    });
                }
                setList([...lst]);
            },
            () => {
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            fetchList();
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded)
            return;
        const filter = search.toUpperCase();
        const lst = document.querySelector('.reports--select-employee-buttons1');
        const btns = (lst as HTMLDivElement).getElementsByTagName('button');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            const v = b.innerHTML.toUpperCase();
            if (v.indexOf(filter) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const saveChanges = (studentId: number, assigned: boolean) => {
        const classId = props.classId;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/class/assign-single',
            {
                c: assigned ? classId.toString() : '0',
                s: studentId.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                }
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={loaded ? {top: 20} : {}}>
                <div className="web-modal-header">
                    <div><b>کلاس {props.classTitle}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="reports--select-employee">
                        {
                            loaded ?
                                <>
                                    <label className="f-roboto">دانش‌آموزان این کلاس را انتخاب کنید.</label>
                                    <div className="pick-device-search">
                                        <button><SearchIcon/></button>
                                        <input type="text"
                                               value={search}
                                               onChange={e => setSearch(e.currentTarget.value)}
                                               onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                               onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                               className="f-roboto" placeholder={"جستجو براساس نام یا پایه تحصیلی..."}
                                        />
                                    </div>
                                    <div className="reports--select-employee-buttons1">
                                        {
                                            list.map((e, i) =>
                                                    <button key={"KJds83jns8932d" + i}
                                                            className={"techaran-checkbox" + (e.isSelected ? ' active' : '') + (!e.isAvailable ? ' is-disabled' : '')}
                                                            onClick={() => setList(v => {
                                                                let x = [...v];
                                                                const id = x.findIndex(r => r.id === e.id);
                                                                if (e.isAvailable) {
                                                                    x[id].isSelected = !x[id].isSelected;
                                                                    saveChanges(e.id, x[id].isSelected);
                                                                }
                                                                return x;
                                                            })}>
                                                        <i>
                                                            {
                                                                e.isAvailable ?
                                                                    <CheckIcon/> :
                                                                    <ThinNotAllowedIcon/>
                                                            }
                                                        </i>
                                                        <span>
                                            {e.firstname + " " + e.lastname}
                                                            <em>{GradeToString(e.grade) + " - " + (e.isAvailable ? (e.isSelected ? 'اختصاص یافته' : 'بدون کلاس') : 'در کلاس دیگر')}</em>
                                        </span>
                                                    </button>
                                            )
                                        }
                                    </div>
                                </> :
                                <div className="d-flex justify-content-center align-items-center"
                                     style={{padding: '70px 0'}}>
                                    <div className="spinner-border" style={{color: '#2b2b2b'}}/>
                                </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};